import type { TaskMessage } from '@camino-solutions/share/proto/common/services';

export class SessionMessageProcessingTaskMessageAction {
  static readonly type = '[Session] Message processing: Task message';

  constructor(readonly taskMessage: TaskMessage) {}
}
